/* global chrome */

export function sendRecordingIndicator(type, conversationID) {
  if (
    typeof chrome !== 'undefined' &&
    chrome.runtime &&
    chrome.runtime.sendMessage
  ) {
    chrome.runtime.sendMessage({ type, conversationID }, () => {
      void chrome.runtime.lastError;
    });
  }
}
